import { render, staticRenderFns } from "./AffiliateBasicDetails.vue?vue&type=template&id=26c29948&scoped=true&"
import script from "./AffiliateBasicDetails.vue?vue&type=script&lang=js&"
export * from "./AffiliateBasicDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c29948",
  null
  
)

export default component.exports